// extracted by mini-css-extract-plugin
export var tosLink = "_56-0";